import { MantineStyleProps, Paper, Text } from '@mantine/core';

import { PRODUCTS } from './const';
import styles from './ProductLink.module.css';

export interface ProductCardProps {
  product: typeof PRODUCTS[number];
  width?: MantineStyleProps['w'];
  variant?: 'standalone' | 'inline';
}

export function ProductLink({ product, variant }: ProductCardProps) {
  const { name, url, letter } = product;
  const isActive = window.location.origin === url;

  const linkProps = !isActive && url
    ? {
        component: 'a' as const,
        href: url,
        target: '_blank',
      }
    : {};

  return (
    <Paper
      className={styles.root}
      shadow="none"
      variant={variant}
      data-active={isActive}
      {...linkProps}
    >
      <div className={styles.logo}>
        {letter ?? name[0]}
      </div>

      <Text ta="center" ff="mono" size="xs" fw={600} tt="uppercase" className={styles.name}>
        {name}
      </Text>
    </Paper>
  );
}
